/* eslint-disable import/no-dynamic-require */
import loadRequire from './loadRequire';

let promise;

export default function loadLodash() {
  if (promise) {
    return promise;
  }
  promise = loadRequire().then((require) => {
    return new Promise((resolve) => {
      require(['lodash'], resolve);
    });
  });
  return promise;
}
